import { useSelector } from 'react-redux';
import { mapPinCoordinatesSelector } from 'slice-reducers/mapSlice';
import { placeDetailsSelector } from 'slice-reducers/locationAndAdvisoriesSlice';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
const styles = {
	main: {
		padding: 20
	},
	lineOne: {
		fontWeight: 'bold'
	},
	title: {
		paddingRight: 5,
		fontWeight: 600
	},
	coordinates: {
		lineHeight: '1.8',
		fontSize: 18
	}
};

const PlaceDetails = ({ mapPin }) => {
	const useStyles = makeStyles(styles);
	const classes = useStyles();
	const mapPinCoordinates = useSelector(mapPinCoordinatesSelector);
	const placeDetails = useSelector(placeDetailsSelector);

	if (placeDetails && placeDetails.place_type) {
		const { address, text, context } = placeDetails;
		let lineOne = '';
		let lineTwo = '';

		// User entered address
		if (placeDetails.place_type[0] === 'address') {
			lineOne = `${address ? address : ''} ${text}`;
			if (context) {
				lineTwo = `${context[2]?.text}, ${context[3]?.text} ${context[1]?.text} ${
					context[3].short_code ? context[3].short_code.toUpperCase() : ''
				}`;
			}
		}

		// User entered city
		if (
			placeDetails.place_type[0] === 'place' ||
			placeDetails.place_type[0] === 'poi' ||
			placeDetails.place_type[0] === 'postcode' ||
			placeDetails.place_type[0] === 'district' ||
			placeDetails.place_type[0] === 'country'
		) {
			lineOne = `${text}`;
			if (context) {
				lineTwo = `${context[0]?.text}, ${context[1]?.text}`;
			}
		}

		// User entered state
		if (placeDetails.place_type[0] === 'region') {
			lineOne = `${text}`;
			if (context) {
				lineTwo = `${context[0]?.text}`;
			}
		}

		const maxChar = 40;
		lineOne = lineOne.length >= maxChar ? `${lineOne.slice(0, maxChar)}...` : lineOne;

		return (
			<div className={classes.main}>
				<Typography variant='h5' className={classes.lineOne}>
					{lineOne}
				</Typography>
				<Typography variant='subtitle1' gutterBottom>
					{lineTwo}
				</Typography>
			</div>
		);
	} else if (mapPinCoordinates.lat && mapPinCoordinates.long) {
		return (
			<div className={classes.main}>
				<Typography className={classes.coordinates} variant='subtitle2'>
					<span className={classes.title}>LAT:</span>
					{Number(mapPinCoordinates.lat).toFixed(8)}
				</Typography>
				<Typography className={classes.coordinates} variant='subtitle2'>
					<span className={classes.title}>LONG:</span>
					{Number(mapPinCoordinates.long).toFixed(8)}
				</Typography>
			</div>
		);
	} else {
		return null;
	}
};

export default PlaceDetails;
